import { MetaType } from 'store/modules/Meta/types';
import StoreHelpers, { store } from 'store/store';

export enum PolicyEnumType {
  Existing = 1,
  Recommended
}

export const humanizePolicyType = (policyType: number) => {
  const state = store.getState();
  const policyTypes = StoreHelpers.selectors.metaSelectors.policyTypes(state);

  const filteredPolicyTypes = policyTypes.filter(
    (type: MetaType) => Number(type.value) === policyType
  );

  return filteredPolicyTypes[0].name;
};
